export const SHOW_TEXT = "RESPONSE_ERROR";
export const RESPONSE_ERROR = "RESPONSE_ERROR";
export const BLEEDING_CURRENT = "BLEEDING_CURRENT";
export const BLEEDING_EDITED = "BLEEDING_EDITED";
export const BLEEDING_CREATED = "BLEEDING_CREATED";
export const BLEEDING_SEARCHED = "BLEEDING_SEARCHED";
export const BLEEDING_SEARCH_REALIZED = "BLEEDING_SEARCH_REALIZED";
